'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('signup', {
    url: '/signup/',
    templateUrl: '/views/signup.html',
    controller: 'SignupCtrl',
    data: {
      hideNavigation: true,
    },
    resolve: {
      auth: authorizationProvider.requireUnauthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Signup - Opencare');
      },
    },
  });

  $stateProvider.state('signup-invite', {
    url: '/signup/:email/:emailToken/',
    templateUrl: '/views/signup.html',
    controller: 'SignupCtrl',
    data: {
      hideNavigation: true,
    },
    resolve: {
      auth: authorizationProvider.requireUnauthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Signup - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('SignupCtrl', function($scope, $state, $base64, $stateParams, CurrentUser, UserService) {
  if ($stateParams.email) {
    try {
      $scope.emailProvided = $base64.decode($stateParams.email);
    } catch (_e) {
      $state.go('home');
    }
  }

  $scope.success = function() {
    if ($scope.emailProvided) {
      // This user param is required by the API and is used to find doctors
      // and/or clinics that are owned by this user and verify their emails as well.
      // We do not require this functionality here.
      UserService.verifyEmail($scope.emailProvided, $stateParams.emailToken, 'not required')['finally'](function() {
        CurrentUser.update(function() {
          $state.go('home');
        });
      });
    } else {
      $state.go('home');
    }
  };

});
